import React from 'react'
import style from '../hiredevloper.module.css'
import linegroup from '../../../assets/linegroup1.png'

const HireNodeJs = () => {
    return (
        <>
            <div className={style.maindiv}>
                <div className={`heading headingborder`}>
                    Hiring Node.js Developers in 3 easy steps
                </div>
                <div className='d-flex justify-content-center'>
                    <h1 className={style.content}>
                        Explore these simple steps that are mentioned below which you can follow to easily hire proficient Node.Js developers from us.
                    </h1>
                </div>
                <div className='row'>
                    <div className="col"></div>
                    <div className="col-8 d-md-flex d-none">
                        <img src={linegroup} className={style.linegroup} alt="Line" />
                    </div>
                    <div className="col"></div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-4 col-sm-6 col-12 p-xl-3 p-lg-2 p-1">
                        <div className={style.step1}>
                            <h1 className={style.boxheading}>Appointment of the best Node.Js Developers</h1>
                            <p className={style.boxcontent}>At Brain Binary Infotech, we appoint a team of the best Node.Js developers who perfectly match your requirements and deliver the best solution.</p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12 p-xl-3 p-lg-2 p-1">
                        <div className={style.step2}>
                            <h1 className={style.boxheading}>Discuss your project requirements and budget with us</h1>
                            <p className={style.boxcontent}>We have a team of experienced NodeJs programmers who understand all the requirements of your business to create the appropriate budget for the development of your app.</p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12 p-xl-3 p-lg-2 p-1">
                        <div className={style.step3}>
                            <h1 className={style.boxheading}>On-Time Delivery of the Project</h1>
                            <p className={style.boxcontent}>Our dedicated team of developers delivers the project upon the agreed timeline and ensures that you can have a cost-effective solution.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HireNodeJs